<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-row>
          <v-card class="" width="500px">
            <v-app-bar dark color="primary">
              <v-toolbar-title>Recuperar contraseña</v-toolbar-title>
            </v-app-bar>
            <v-card-text>
              <v-text-field
                @keydown.enter.prevent="login"
                label="NUEVA CONTRASEÑA"
                v-model="contrasena"
                prepend-icon="mdi-key"
                :type="showpass ? 'text' : 'password'"
                :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass = !showpass"
              ></v-text-field>
              <v-text-field
                @keydown.enter.prevent="login"
                label="REPITA CONTRASEÑA"
                v-model="repitacontrasena"
                prepend-icon="mdi-key"
                :type="showpass2 ? 'text' : 'password'"
                :append-icon="showpass2 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showpass2 = !showpass2"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valida" @click="recuperar" class="primary"
                >Recuperar</v-btn
              >
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn link :to="{name: 'Autogestion'}" class="green" dark
                >Ir a la pagina de inicio</v-btn
              >
            </v-card-actions>
          </v-card>
          <h4 class="red--text">{{ observaciones }}</h4>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import API from "../../lib/API";
export default {
  data() {
    return {
      valida: true,
      showpass: false,
      showpass2: false,
      contrasena: "",
      repitacontrasena: "",
    };
  },
  computed: {
    idafiliado() {
      return this.$route.params.idafiliado;
    },
    token() {
      return this.$route.params.token;
    },
    observaciones() {
      this.valida = true;
      let obs = "";
      if (this.contrasena !== this.repitacontrasena) {
        obs += " * no coinciden las contraseñas";
      }
      if (this.contrasena == "") {
        obs += " * ingrese la nueva contraseña";
      } else {
        if (this.contrasena.length < 6) {
          obs += " * minimo 6 caracteres";
        }
      }

      if (obs) {
        this.valida = false;
      }

      return obs;
    },
  },
  methods: {
    async recuperar() {
      if (this.valida) {
       let ret = await API.UsuariosBeneficiarios.RecuperarPass({
          id_afiliado: this.idafiliado,
          password: this.contrasena,
          token: this.token,
        });
      }
    },
  },
};
</script>

<style></style>
